module.exports = __webpack_public_path__ + "assets/background-steps.06d36d84.svg";